/* Product Box V2 — moved out of the section file to stay under
   Shopify's section-file size cap. Reads config from
   window.__pbConfigs[sectionId], emitted inline by the section. */
(function() {
  function init(sid) {
    var cfg = window.__pbConfigs && window.__pbConfigs[sid];
    if (!cfg) return;
  (function() {
    var section = document.querySelector('[data-section-id=\"' + sid + '\"]');
    if (!section) return;

    /* ============================================================
       Editor scroll-jump mitigation v3 — scroll-event-based detection.

       Previous versions hooked Shopify's lifecycle events
       (shopify:section:unload/load, shopify:block:select) to know when
       to pin scroll. That worked for full section reloads but missed
       block-setting edits — especially live-preview-style changes
       (color, range sliders dragged) that update the iframe via
       mechanisms which bypass those events. The user kept getting
       pushed to the bottom on Qty & Flavors block edits.

       This version is event-source-agnostic. It listens directly to
       `scroll` events:

         - User-initiated scrolls (preceded by wheel/touch/key/pointer
           input within 500ms) are accepted and update the baseline.
         - Programmatic scrolls (no recent user input) that jump >200px
           are reverted instantly to the last user-confirmed position,
           AND a 1500ms lock window starts. During the lock, even
           smaller programmatic drifts get reverted (catches Shopify's
           smooth-scroll animation that crawls toward the bottom over
           many frames).
         - Lifecycle events still arm the lock as a defensive belt-
           and-suspenders, but the scroll-event detector is the
           primary mechanism.
       ============================================================ */
    if (window.Shopify && window.Shopify.designMode) {
      var sectionDomId = 'shopify-section-' + sid;
      var lastValidY = window.scrollY;
      var lastUserInputAt = 0;
      var lockUntil = 0;

      function nowMs() {
        return (window.performance && performance.now) ? performance.now() : Date.now();
      }

      function markUserInput() {
        lastUserInputAt = nowMs();
        lastValidY = window.scrollY;
        lockUntil = 0;            /* user input cancels any active lock */
      }
      ['wheel', 'touchstart', 'touchmove', 'keydown', 'pointerdown'].forEach(function(ev) {
        window.addEventListener(ev, markUserInput, { passive: true, capture: true });
      });

      window.addEventListener('scroll', function() {
        var now = nowMs();
        var sinceUserInput = now - lastUserInputAt;
        var newY = window.scrollY;
        var delta = Math.abs(newY - lastValidY);
        var userActive = sinceUserInput < 500;

        if (userActive) {
          lastValidY = newY;
          return;
        }

        /* Programmatic scroll detected. */
        if (delta > 200) {
          /* Sudden jump (Shopify's auto-scroll-to-block) — revert and lock. */
          window.scrollTo({ top: lastValidY, left: 0, behavior: 'instant' });
          lockUntil = now + 1500;
          return;
        }

        if (now < lockUntil && delta > 5) {
          /* Inside lock window — revert smaller drifts too (catches smooth
             scroll animations that Shopify chains after the initial jump). */
          window.scrollTo({ top: lastValidY, left: 0, behavior: 'instant' });
          return;
        }

        /* Otherwise accept (programmatic scroll outside lock & under threshold —
           probably benign, like browser autofill or anchor jumps). */
        lastValidY = newY;
      }, { passive: true });

      /* Lifecycle hooks: pre-arm the lock so the very first scroll event
         after a known editor action hits a hot detector. Also captures
         the pre-disruption scrollY before any auto-scroll fires. */
      function armLock(durationMs) {
        lockUntil = Math.max(lockUntil, nowMs() + durationMs);
        if ((nowMs() - lastUserInputAt) > 500) {
          lastValidY = window.scrollY;
        }
      }

      document.addEventListener('shopify:section:unload', function(e) {
        if (e.target && e.target.id === sectionDomId) armLock(2000);
      });
      document.addEventListener('shopify:section:load', function(e) {
        if (e.target && e.target.id === sectionDomId) armLock(2000);
      });
      document.addEventListener('shopify:block:select', function(e) {
        var sec = document.getElementById(sectionDomId);
        if (sec && e.target && sec.contains(e.target)) armLock(2000);
      });
      document.addEventListener('shopify:block:deselect', function(e) {
        var sec = document.getElementById(sectionDomId);
        if (sec && e.target && sec.contains(e.target)) armLock(1000);
      });
    }

    /* ============================================================
       Product Data — mutable so we can swap when formula changes
       ============================================================ */
    var productData = cfg.productData;
    /* Fall back to direct Liquid variant serialization if productData.variants is empty */
    var variants = (productData && productData.variants && productData.variants.length > 0)
      ? productData.variants
      : cfg.productVariantsFallback;
    var variantInput = section.querySelector('[data-variant-id]');
    var quantityInput = section.querySelector('[data-quantity-input]');
    var atcButton = section.querySelector('[data-atc-button]');
    var atcText = section.querySelector('[data-atc-text]');
    var ctaLabel = cfg.ctaLabel;

    /* Option indices (0-based) so JS can match the right variant option */
    var flavorOptionIndex   = cfg.flavorOptionIndex;
    var formulaOptionIndex  = cfg.formulaOptionIndex;
    var quantityOptionIndex = cfg.quantityOptionIndex;

    /* Cache fetched AJAX product data (don't pre-seed with Liquid JSON
       since its format differs from /products/{handle}.js) */
    var originalHandle = cfg.originalHandle;
    var currentHandle = originalHandle;
    var productCache = {};

    /* --- Track Current Selections --- */
    var currentSelections = {
      formula: cfg.initialFormula,
      flavor: cfg.initialFlavor,
      quantity: cfg.initialQuantity
    };

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    /* Base variant — flavor + formula only, no quantity.
       Used as the unit price for quantity price calculations. */
    function findBaseVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = [v.option1, v.option2, v.option3];
        if (flavorOptionIndex >= 0 && currentSelections.flavor && opts[flavorOptionIndex] !== currentSelections.flavor) continue;
        if (formulaOptionIndex >= 0 && currentSelections.formula && opts[formulaOptionIndex] !== currentSelections.formula) continue;
        return v;
      }
      return variants[0] || null;
    }

    /* Full variant match — flavor + formula + quantity.
       Used to get the correct variant ID for cart submission. */
    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = [v.option1, v.option2, v.option3];
        if (flavorOptionIndex >= 0 && currentSelections.flavor && opts[flavorOptionIndex] !== currentSelections.flavor) continue;
        if (formulaOptionIndex >= 0 && currentSelections.formula && opts[formulaOptionIndex] !== currentSelections.formula) continue;
        if (quantityOptionIndex >= 0 && currentSelections.quantity && opts[quantityOptionIndex] !== currentSelections.quantity) continue;
        return v;
      }
      return findBaseVariant();
    }

    /* ============================================================
       Carousel & Thumbnail Rebuilding
       ============================================================ */
    function rebuildCarouselAndThumbs(data) {
      var carousel = section.querySelector('[data-carousel]');
      var thumbWrap = section.querySelector('[data-thumbnails]');

      /* Build image list with alt text from media if available */
      var mediaList = (data.media || []).filter(function(m) { return m.media_type === 'image'; });
      var imageEntries = [];
      if (mediaList.length) {
        mediaList.forEach(function(m) {
          imageEntries.push({ src: m.src || (m.preview_image && m.preview_image.src) || '', alt: (m.alt || '').toLowerCase().trim() });
        });
      } else {
        /* Fallback to images array */
        (data.images || []).forEach(function(img) {
          var src = (typeof img === 'object' && img.src) ? img.src : String(img);
          imageEntries.push({ src: src, alt: '' });
        });
      }
      if (!carousel || !imageEntries.length) return;

      /* Rebuild main carousel slides */
      carousel.innerHTML = '';
      imageEntries.forEach(function(entry, idx) {
        var slide = document.createElement('div');
        slide.className = 'product-box__image-slide';
        slide.setAttribute('data-slide-index', idx);
        slide.setAttribute('data-media-alt', entry.alt);
        var img = document.createElement('img');
        img.src = entry.src;
        img.alt = entry.alt || data.title || '';
        img.width = 600;
        img.height = 600;
        img.loading = idx === 0 ? 'eager' : 'lazy';
        slide.appendChild(img);
        carousel.appendChild(slide);
      });
      /* Scroll to first slide */
      carousel.scrollTo({ left: 0, behavior: 'auto' });

      /* Rebuild thumbnails */
      if (thumbWrap) {
        thumbWrap.innerHTML = '';
        imageEntries.forEach(function(entry, idx) {
          var btn = document.createElement('button');
          btn.className = 'product-box__thumbnail' + (idx === 0 ? ' is-active' : '');
          btn.setAttribute('data-thumbnail-index', idx);
          btn.setAttribute('data-media-alt', entry.alt);
          btn.setAttribute('type', 'button');
          btn.setAttribute('aria-label', 'View image ' + (idx + 1));
          var img = document.createElement('img');
          img.src = entry.src;
          img.alt = entry.alt;
          img.width = 60;
          img.height = 60;
          img.loading = 'lazy';
          btn.appendChild(img);
          /* Click handler */
          btn.addEventListener('click', function() {
            carousel.scrollTo({ left: idx * carousel.clientWidth, behavior: 'smooth' });
            updateActiveThumb(idx);
            updateSliderBar(idx, imageEntries.length);
          });
          thumbWrap.appendChild(btn);
        });
      }

      /* Update slider bar for new slide count */
      var sliderBar = section.querySelector('[data-slider-bar]');
      if (sliderBar) {
        var seg = 100 / imageEntries.length;
        var pill = sliderBar.querySelector('[data-slider-pill]');
        if (pill) { pill.style.width = seg + '%'; pill.style.left = '0%'; }
      }

      /* Refresh stored slides/thumbs for flavor filtering */
      _allSlides = [];
      _allThumbs = [];
      if (carousel) Array.prototype.forEach.call(carousel.children, function(s) {
        _allSlides.push({ html: s.outerHTML, alt: (s.getAttribute('data-media-alt') || '').trim() });
      });
      if (thumbWrap) Array.prototype.forEach.call(thumbWrap.children, function(th) {
        _allThumbs.push({ html: th.outerHTML, alt: (th.getAttribute('data-media-alt') || '').trim() });
      });
    }

    /* ============================================================
       Filter images by flavor alt text
       — Rebuilds carousel & thumbnails with only matching slides
       ============================================================ */
    /* Store all original slides and thumbs on first run */
    var _allSlides = [];
    var _allThumbs = [];
    (function() {
      var c = section.querySelector('[data-carousel]');
      var t = section.querySelector('[data-thumbnails]');
      if (c) Array.prototype.forEach.call(c.children, function(s) {
        _allSlides.push({ html: s.outerHTML, alt: (s.getAttribute('data-media-alt') || '').trim() });
      });
      if (t) Array.prototype.forEach.call(t.children, function(th) {
        _allThumbs.push({ html: th.outerHTML, alt: (th.getAttribute('data-media-alt') || '').trim() });
      });
    })();

    function filterImagesByFlavor(flavor) {
      var carousel = section.querySelector('[data-carousel]');
      var thumbWrap = section.querySelector('[data-thumbnails]');
      var sliderBarEl = section.querySelector('[data-slider-bar]');
      if (!carousel) return;

      var flavorLower = (flavor || '').toLowerCase().trim();

      /* Filter to matching slides */
      var filtered = _allSlides.filter(function(s) {
        return !s.alt || !flavorLower || s.alt === flavorLower;
      });
      var filteredThumbs = _allThumbs.filter(function(s) {
        return !s.alt || !flavorLower || s.alt === flavorLower;
      });

      /* Rebuild carousel */
      carousel.innerHTML = '';
      filtered.forEach(function(entry, idx) {
        var tmp = document.createElement('div');
        tmp.innerHTML = entry.html;
        var slide = tmp.firstElementChild;
        slide.setAttribute('data-slide-index', idx);
        carousel.appendChild(slide);
      });

      /* Rebuild thumbnails */
      if (thumbWrap) {
        thumbWrap.innerHTML = '';
        filteredThumbs.forEach(function(entry, idx) {
          var tmp = document.createElement('div');
          tmp.innerHTML = entry.html;
          var thumb = tmp.firstElementChild;
          thumb.setAttribute('data-thumbnail-index', idx);
          thumb.classList.toggle('is-active', idx === 0);
          /* Rebind click */
          thumb.addEventListener('click', function() {
            carousel.scrollTo({ left: idx * carousel.clientWidth, behavior: 'smooth' });
            updateActiveThumb(idx);
            updateSliderBar(idx, filtered.length);
          });
          thumbWrap.appendChild(thumb);
        });
      }

      /* Reset scroll */
      carousel.scrollLeft = 0;

      /* Update slider bar */
      if (sliderBarEl && filtered.length > 0) {
        var pill = sliderBarEl.querySelector('[data-slider-pill]');
        if (pill) {
          pill.style.width = (100 / filtered.length) + '%';
          pill.style.left = '0%';
        }
      }
    }

    function scrollToVariantImage() {
      var variant = findVariant();
      if (!variant || !variant.featured_image) return;
      var carousel = section.querySelector('[data-carousel]');
      if (!carousel) return;
      /* Extract filename stem from variant featured_image for flexible matching */
      var featuredSrc = variant.featured_image.src || '';
      var featuredFile = featuredSrc.split('/').pop().split('?')[0].split('#')[0];
      var slides = carousel.querySelectorAll('.product-box__image-slide');
      var matched = false;
      slides.forEach(function(slide, idx) {
        if (matched) return;
        var img = slide.querySelector('img');
        if (!img) return;
        var slideSrc = (img.src || '').split('/').pop().split('?')[0].split('#')[0];
        if (featuredFile && slideSrc && slideSrc.indexOf(featuredFile) !== -1) {
          carousel.scrollTo({ left: idx * carousel.clientWidth, behavior: 'smooth' });
          updateActiveThumb(idx);
          updateSliderBar(idx, slides.length);
          matched = true;
        }
      });
    }

    /* --- Dynamic Quantity Pricing ---
       price = variant.price × multiplier × (1 - discount/100)
       per-serving = discounted total ÷ servings
    */
    function getQtyPrice(unitPriceCents, opt) {
      var multiplier = parseFloat(opt.getAttribute('data-multiplier')) || 0;
      /* Always cross-check with variant option text (e.g. "2 Boxes" → 2).
         Use whichever value is LARGER so default schema value of 1 doesn't
         mask a genuine 2-box option whose block setting wasn't configured. */
      var optText = opt.getAttribute('data-variant-option') || '';
      var textMultiplier = parseInt(optText, 10) || 0;
      if (textMultiplier > multiplier) multiplier = textMultiplier;
      if (multiplier < 1) multiplier = 1;

      var discount = parseFloat(opt.getAttribute('data-discount')) || 0;

      /* Per-formula dollar discount override: data-discount-amount (cents off the multiplied subtotal) */
      var discountAmountCents = parseFloat(opt.getAttribute('data-discount-amount-cents')) || 0;
      if (discountAmountCents > 0) {
        var subtotal = unitPriceCents * multiplier;
        return Math.round(subtotal - discountAmountCents);
      }

      /* Fallback: if multi-box but no block-level discount, use section default */
      if (discount === 0 && multiplier > 1) {
        var qtyWrap = opt.closest('[data-quantity-options]');
        if (qtyWrap) discount = parseFloat(qtyWrap.getAttribute('data-multi-discount')) || 0;
      }
      var total = unitPriceCents * multiplier;
      if (discount > 0) total = Math.round(total * (1 - discount / 100));
      return total;
    }

    function updateQuantityPrices() {
      var baseVariant = findBaseVariant();
      if (!baseVariant) return;
      var unitPrice = baseVariant.price; /* cents — always the single-unit price */

      section.querySelectorAll('.product-box__quantity-option').forEach(function(opt) {
        /* `data-servings` is the TOTAL servings for this quantity option,
           NOT per-box — merchants enter the total visible to the customer
           (e.g. "30 Sticks" for a 2-box Hydration option, "30 Packets"
           for Whey's 3-box option). Don't multiply by the box count
           here or you double-count and the per-serving display halves
           or thirds incorrectly. */
        var totalServings = parseInt(opt.getAttribute('data-servings'), 10) || 1;
        var totalCents = getQtyPrice(unitPrice, opt);
        var perServing = totalCents / totalServings;

        /* Stamp the calculated price so updateVariant can read it directly */
        opt.setAttribute('data-price-cents', totalCents);

        var priceEl = opt.querySelector('[data-qty-price]');
        var servingEl = opt.querySelector('[data-qty-serving]');
        // Always-dynamic prices: rewrite both text nodes from the
        // computed values. Liquid no longer emits data-fixed-text; the
        // merchant's typed q1_price etc. only renders server-side as
        // an initial fallback before this JS runs. Source of truth is
        // Shopify variant.price for every product.
        if (priceEl) priceEl.textContent = formatMoney(totalCents);
        if (servingEl) servingEl.textContent = formatMoney(perServing) + ' Serving';
      });
    }

    function updateVariant() {
      /* Stamp data-price-cents on all qty options first so the ATC price read is current */
      updateQuantityPrices();

      var variant = findVariant();
      if (variant) {
        variantInput.value = variant.id;
        atcButton.disabled = !variant.available;

        /* ATC price: read from data-price-cents stamped above by updateQuantityPrices() */
        var selectedQty = section.querySelector('.product-box__quantity-option.is-selected');
        var priceCents = selectedQty ? parseInt(selectedQty.getAttribute('data-price-cents'), 10) : NaN;
        var displayPrice = !isNaN(priceCents) ? priceCents : variant.price;

        atcText.textContent = variant.available
          ? ctaLabel + '  -  ' + formatMoney(displayPrice)
          : 'SOLD OUT';

        /* Update URL without reload */
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);

        /* Scroll carousel to variant image */
        scrollToVariantImage();
      }
    }

    /* ============================================================
       Mix-Flavor Dropdown Rebuilding
       ============================================================ */
    function rebuildMixFlavorDropdowns(data) {
      var select1 = section.querySelector('[data-mix-flavor-1]');
      var select2 = section.querySelector('[data-mix-flavor-2]');
      if (!select1 && !select2) return;

      /* Find the Flavor option index in the new product.
         Handle both AJAX formats:
           /products/{handle}.js  → options: ["Flavor", "Quantity"]  (strings)
           /products/{handle}.json → options: [{name:"Flavor",…}]   (objects) */
      var flavorIdx = -1;
      var opts = data.options || [];
      for (var i = 0; i < opts.length; i++) {
        var optName = (typeof opts[i] === 'string') ? opts[i] : (opts[i] && opts[i].name ? opts[i].name : '');
        if (optName.toLowerCase() === 'flavor') { flavorIdx = i; break; }
      }
      if (flavorIdx === -1 && opts.length > 0) flavorIdx = 0; /* fallback to first option */

      /* Collect unique flavor values from variants */
      var flavors = [];
      (data.variants || []).forEach(function(v) {
        var val = v['option' + (flavorIdx + 1)];
        if (val && flavors.indexOf(val) === -1) flavors.push(val);
      });

      /* Rebuild both select elements */
      [select1, select2].forEach(function(sel, idx) {
        if (!sel) return;
        var label = 'Select Flavor ' + (idx + 1);
        sel.innerHTML = '';
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = label;
        sel.appendChild(placeholder);
        flavors.forEach(function(f) {
          var option = document.createElement('option');
          option.value = f;
          option.textContent = f;
          sel.appendChild(option);
        });
        /* Reset flavor dot color */
        var wrap = sel.closest('.product-box__mix-flavor-select-wrap');
        if (wrap) {
          wrap.style.setProperty('--flavor-dot-color', 'transparent');
          wrap.style.setProperty('--flavor-dot-border', 'var(--pb-color-primary)');
        }
      });
    }

    /* ============================================================
       AJAX Product Switching — fetch /products/{handle}.js
       ============================================================ */
    function switchProduct(handle, flavorValue) {
      function applyProductData(data) {
        productData = data;
        variants = data.variants || [];
        currentHandle = handle;
        currentSelections.flavor = flavorValue;

        /* Rebuild carousel + thumbnails with new product images */
        rebuildCarouselAndThumbs(data);

        /* Filter images for the selected flavor */
        filterImagesByFlavor(flavorValue);

        /* Update product title to reflect switched product */
        var titleEl = section.querySelector('.product-box__title');
        if (titleEl && data.title) titleEl.textContent = data.title;

        /* Update product description to reflect switched product. The description
           block renders product.description (no typed override in the templates),
           so on a cross-product flavour switch we swap in the new product's
           description (the /products/{handle}.js payload returns it as `description`).
           Descriptions carry `intro <!--more--> spec paragraph` for the agentic
           catalog/JSON-LD; only the intro renders on the PDP, matching the
           Liquid-side split in the product-box sections. */
        var descEl = section.querySelector('.product-box__description');
        if (descEl && typeof data.description === 'string' && data.description !== '') {
          descEl.innerHTML = data.description.split('<!--more-->')[0];
        }

        /* Update formula group active states */
        section.querySelectorAll('.product-box__formula-group').forEach(function(group) {
          var groupHandle = group.getAttribute('data-group-handle');
          group.classList.toggle('is-active', groupHandle === currentHandle);
        });

        /* Swap feature list to match active formula */
        var activeFormula = section.querySelector('.product-box__formula-group.is-active');
        if (activeFormula) {
          var formulaValue = activeFormula.getAttribute('data-formula-group');
          section.querySelectorAll('[data-formula-features]').forEach(function(featList) {
            var match = featList.getAttribute('data-formula-value') === formulaValue;
            if (match) {
              featList.removeAttribute('hidden');
              featList.setAttribute('data-active', 'true');
            } else {
              featList.setAttribute('hidden', '');
              featList.removeAttribute('data-active');
            }
          });
        }

        /* Rebuild mix-flavor dropdown options for the new product */
        try { rebuildMixFlavorDropdowns(data); } catch(e) { console.error('[ProductBox] rebuildMixFlavorDropdowns error:', e); }

        applyFormulaDiscounts();
        updateVariant();

        /* Update the "N REVIEWS" count to the switched product. The rating lives
           in a metafield (not in /products/{handle}.js), so read the count stamped
           server-side on the matching formula group. */
        try {
          var swFg = section.querySelector('.product-box__formula-group[data-group-handle="' + handle + '"]');
          var rcEl = section.querySelector('.product-box__rating-count');
          var rLink = section.querySelector('.product-box__rating-link');
          if (swFg && rcEl) {
            var rCount = parseInt(swFg.getAttribute('data-rating-count'), 10) || 0;
            if (rCount > 0) {
              var rLabel = rcEl.textContent.replace(/^[\d,\s]+/, '') || 'REVIEWS';
              rcEl.textContent = rCount + ' ' + rLabel;
              if (rLink) rLink.style.removeProperty('display');
            } else if (rLink) {
              rLink.style.display = 'none';
            }
          }
        } catch (e) {}

        /* Broadcast the in-page product switch so OTHER sections (reviews, etc.)
           can swap their product-scoped content. Reusable hook: any section
           listens for 'cx:product-switched' and re-renders itself for
           detail.handle / detail.productId. */
        try {
          document.dispatchEvent(new CustomEvent('cx:product-switched', {
            detail: { handle: data.handle || handle, productId: data.id, title: data.title }
          }));
        } catch (e) {}
      }

      if (productCache[handle]) {
        applyProductData(productCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productCache[handle] = data;
          applyProductData(data);
        })
        .catch(function(err) {
          console.error('Failed to fetch product:', err);
        });
    }

    /* ============================================================
       Flavor Card Selection
       ============================================================ */
    var flavorCards = section.querySelectorAll('.product-box__flavor-card');
    flavorCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var flavorValue = card.getAttribute('data-flavor-value');
        var targetHandle = card.getAttribute('data-product-handle');

        /* Deselect all, select this */
        flavorCards.forEach(function(c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');

        if (targetHandle && targetHandle !== currentHandle) {
          /* Different product — switch via AJAX */
          switchProduct(targetHandle, flavorValue);
        } else {
          /* Same product — just update selections + filter images + scroll */
          currentSelections.flavor = flavorValue;
          currentSelections.formula = card.getAttribute('data-formula-value');
          filterImagesByFlavor(flavorValue);
          updateVariant();
        }
      });
    });

    /* ============================================================
       Quantity Option Selection
       ============================================================ */

    /* === Per-formula dollar-amount discount overrides ===
       Each formula group can declare a $ off per quantity tier (2-box,
       3-box, 4-box, 5-box). Reads them from the formula-group data
       attributes that the Liquid emits. Hydration vs +BCAAs can have
       different discount amounts since the merchant sets each formula's
       multi-box savings independently. The dollar value gets stamped
       on the quantity option as data-discount-amount-cents (integer
       cents) for the price math to consume verbatim — no percentage
       rounding drift. Match these values to the Shopify automatic
       discounts created in admin so the cart total equals the displayed
       PDP price exactly. */
    function applyFormulaDiscounts() {
      var activeGroup = section.querySelector('.product-box__formula-group.is-active');
      if (!activeGroup) return;
      var perTier = {
        2: parseFloat(activeGroup.getAttribute('data-discount-2box')) || 0,
        3: parseFloat(activeGroup.getAttribute('data-discount-3box')) || 0,
        4: parseFloat(activeGroup.getAttribute('data-discount-4box')) || 0,
        5: parseFloat(activeGroup.getAttribute('data-discount-5box')) || 0
      };
      section.querySelectorAll('.product-box__quantity-option').forEach(function(opt) {
        var mult = parseFloat(opt.getAttribute('data-multiplier')) || 1;
        var optText = opt.getAttribute('data-variant-option') || '';
        var textMult = parseInt(optText, 10) || 0;
        if (textMult > mult) mult = textMult;
        var dollarsOff = perTier[mult] || 0;
        if (dollarsOff > 0) {
          opt.setAttribute('data-discount-amount-cents', Math.round(dollarsOff * 100));
        } else {
          opt.removeAttribute('data-discount-amount-cents');
        }
      });
    }

    var qtyOptions = section.querySelectorAll('.product-box__quantity-option');
    var toggleWrap = section.querySelector('[data-toggle-wrap]');
    var mixSection = section.querySelector('[data-mix-flavor-section]');

    function updateToggleVisibility(opt) {
      if (!toggleWrap) return;
      /* Check multiple sources: multiplier attribute, variant option text, or label text */
      var multiplier = parseInt(opt.getAttribute('data-multiplier'), 10) || 0;
      var optionVal = opt.getAttribute('data-variant-option') || '';
      var boxCount = parseInt(optionVal, 10) || 0;
      var isMulti = multiplier > 1 || boxCount > 1;
      toggleWrap.style.display = isMulti ? '' : 'none';
      if (!isMulti && mixSection) {
        mixSection.classList.remove('is-visible');
        mixSection.querySelectorAll('.product-box__mix-flavor-select').forEach(function(d) { d.disabled = true; });
        var tog = section.querySelector('[data-flavor-toggle]');
        if (tog) {
          tog.setAttribute('data-active', 'single');
          tog.querySelectorAll('.product-box__toggle-option').forEach(function(o) {
            var isSingle = o.getAttribute('data-toggle-value') === 'single';
            o.classList.toggle('is-active', isSingle);
            o.setAttribute('aria-selected', isSingle ? 'true' : 'false');
          });
        }
      }
    }

    // Helper: swap role between 'radio' (unselected) and 'group' (selected
    // / expanded; contains nested interactive children). Avoids the WCAG
    // nested-interactive violation since role="radio" can't contain
    // focusable children. Removes tabindex on selected option (already
    // active, user reaches inner controls via Tab); restores tabindex
    // on the previously-selected option as it deselects.
    function setSelectedAria(selectedOpt, allOpts) {
      allOpts.forEach(function(o) {
        if (o === selectedOpt) {
          o.setAttribute('role', 'group');
          o.setAttribute('aria-label', 'Selected quantity option');
          o.removeAttribute('tabindex');
          o.setAttribute('aria-checked', 'true');
        } else {
          o.setAttribute('role', 'radio');
          o.removeAttribute('aria-label');
          o.setAttribute('tabindex', '0');
          o.setAttribute('aria-checked', 'false');
        }
      });
    }
    qtyOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        setSelectedAria(opt, qtyOptions);
        qtyOptions.forEach(function(o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        currentSelections.quantity = opt.getAttribute('data-variant-option');
        var qtyVal = opt.getAttribute('data-quantity-value');
        if (qtyVal && quantityInput) quantityInput.value = qtyVal;
        updateToggleVisibility(opt);
        updateVariant();
      });

      opt.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });

    /* ============================================================
       Flavor Mode Toggle (Single / Mix)
       ============================================================ */
    var toggle = section.querySelector('[data-flavor-toggle]');
    if (toggle) {
      var toggleOptions = toggle.querySelectorAll('.product-box__toggle-option');
      toggleOptions.forEach(function(opt) {
        opt.addEventListener('click', function() {
          var value = opt.getAttribute('data-toggle-value');
          toggle.setAttribute('data-active', value);
          toggleOptions.forEach(function(o) {
            o.classList.remove('is-active');
            o.setAttribute('aria-selected', 'false');
          });
          opt.classList.add('is-active');
          opt.setAttribute('aria-selected', 'true');
          if (mixSection) {
            mixSection.classList.toggle('is-visible', value === 'mix');
            /* Disable dropdowns when not in mix mode so they don't submit as form properties */
            mixSection.querySelectorAll('.product-box__mix-flavor-select').forEach(function(d) {
              d.disabled = (value !== 'mix');
            });
          }
        });
      });
    }

    /* ============================================================
       Image Carousel + Thumbnails
       ============================================================ */
    var carousel = section.querySelector('[data-carousel]');
    var sliderBar = section.querySelector('[data-slider-bar]');

    function updateActiveThumb(activeIndex) {
      /* Always query fresh DOM so rebuilt thumbnails are found */
      var allThumbs = section.querySelectorAll('.product-box__thumbnail');
      allThumbs.forEach(function(t) { t.classList.remove('is-active'); });
      var target = section.querySelector('[data-thumbnail-index="' + activeIndex + '"]');
      if (target) {
        target.classList.add('is-active');
        /* Auto-scroll thumbnail strip to keep active thumb centred */
        var thumbWrap = target.parentElement;
        if (thumbWrap) {
          var scrollTarget = target.offsetLeft - thumbWrap.offsetLeft
            - (thumbWrap.clientWidth / 2) + (target.offsetWidth / 2);
          thumbWrap.scrollTo({
            left: Math.max(0, scrollTarget),
            behavior: 'smooth'
          });
        }
      }
    }

    function updateSliderBar(activeIndex, totalSlides) {
      if (!sliderBar) return;
      var pill = sliderBar.querySelector('[data-slider-pill]');
      if (!pill) return;
      var segPct = 100 / totalSlides;
      pill.style.width = segPct + '%';
      pill.style.left = (activeIndex * segPct) + '%';
    }

    function updateArrowState() {
      if (!carousel) return;
      var total = carousel.children.length;
      if (total <= 1) return;
      var current = Math.round(carousel.scrollLeft / carousel.clientWidth);
      section.querySelectorAll('[data-carousel-prev]').forEach(function(btn) {
        if (current <= 0) { btn.setAttribute('disabled', ''); }
        else { btn.removeAttribute('disabled'); }
      });
      section.querySelectorAll('[data-carousel-next]').forEach(function(btn) {
        if (current >= total - 1) { btn.setAttribute('disabled', ''); }
        else { btn.removeAttribute('disabled'); }
      });
    }

    if (carousel) {
      carousel.addEventListener('scroll', function() {
        var scrollLeft = carousel.scrollLeft;
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (maxScroll > 0) {
          var total = carousel.children.length;
          var currentIndex = Math.round(scrollLeft / carousel.clientWidth);
          if (sliderBar) updateSliderBar(currentIndex, total);
          updateActiveThumb(currentIndex);
          updateArrowState();
        }
      });
    }

    section.querySelectorAll('.product-box__thumbnail').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = parseInt(thumb.getAttribute('data-thumbnail-index'), 10);
        if (carousel) carousel.scrollTo({ left: index * carousel.clientWidth, behavior: 'smooth' });
        updateActiveThumb(index);
        if (sliderBar && carousel) updateSliderBar(index, carousel.children.length);
      });
    });

    /* Prev / Next arrow buttons — scroll one slide at a time, clamp at ends. */
    function goToSlide(index) {
      if (!carousel) return;
      var total = carousel.children.length;
      var clamped = Math.max(0, Math.min(total - 1, index));
      carousel.scrollTo({ left: clamped * carousel.clientWidth, behavior: 'smooth' });
      updateActiveThumb(clamped);
      if (sliderBar) updateSliderBar(clamped, total);
      updateArrowState();
    }
    /* Initial state: with scrollLeft=0, prev should start disabled. */
    updateArrowState();
    section.querySelectorAll('[data-carousel-prev]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!carousel) return;
        var current = Math.round(carousel.scrollLeft / carousel.clientWidth);
        goToSlide(current - 1);
      });
    });
    section.querySelectorAll('[data-carousel-next]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!carousel) return;
        var current = Math.round(carousel.scrollLeft / carousel.clientWidth);
        goToSlide(current + 1);
      });
    });

    /* ============================================================
       Flavor Dot Colors (mix flavor dropdowns)
       ============================================================ */
    var flavorColors = {};
    try { flavorColors = JSON.parse(cfg.flavorColorsJson); } catch(e) {}

    function updateFlavorDot(selectEl) {
      var wrap = selectEl.closest('.product-box__mix-flavor-select-wrap');
      if (!wrap) return;
      var color = flavorColors[selectEl.value] || '';
      wrap.style.setProperty('--flavor-dot-color', color || 'transparent');
      wrap.style.setProperty('--flavor-dot-border', color || 'var(--pb-color-primary)');
    }

    var flavorSelect1 = section.querySelector('[data-mix-flavor-1]');
    var flavorSelect2 = section.querySelector('[data-mix-flavor-2]');
    if (flavorSelect1) {
      flavorSelect1.addEventListener('change', function() { updateFlavorDot(flavorSelect1); });
      updateFlavorDot(flavorSelect1);
    }
    if (flavorSelect2) {
      flavorSelect2.addEventListener('change', function() { updateFlavorDot(flavorSelect2); });
      updateFlavorDot(flavorSelect2);
    }

    /* ============================================================
       Initialisation
       ============================================================ */
    /* Set initial toggle visibility based on default (first) qty option */
    var defaultQty = section.querySelector('.product-box__quantity-option.is-selected');
    if (defaultQty) updateToggleVisibility(defaultQty);

    /* Filter images for the initially selected flavor */
    if (currentSelections.flavor) filterImagesByFlavor(currentSelections.flavor);

    /* Run full variant + pricing update so ATC price & qty displays
       are dynamic from the very first render */
    updateVariant();

    /* ============================================================
       ATC — Cart Drawer or Direct Checkout
       ============================================================ */
    var directToCheckout = cfg.directToCheckout;
    var form = section.querySelector('[data-product-form]');

    if (form && atcButton) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (atcButton.disabled) return;

        /* === Defense: strip stray properties[...] inputs ===
           Originally written to defend against Simple Bundles' widget
           injecting hidden selects with conflicting property names. SB
           was uninstalled 2026-05-26, so the SB-specific container
           cleanup is gone. The aggressive sweep is kept as a general
           safety net — if any future Shopify app injects properties[
           inputs onto our product form, this scopes them out.

           Logic: when our visible flavor block is in this form, remove
           ALL properties[...] inputs OUTSIDE [data-flavor-block]. Non-
           SystemX product pages are unaffected (their flavor selects
           aren't inside a data-flavor-block wrapper). */
        var flavorBlockEl = form.querySelector('[data-flavor-block]');
        if (flavorBlockEl) {
          form.querySelectorAll('[name^="properties["]').forEach(function(el) {
            if (!el.closest('[data-flavor-block]')) {
              if (el.parentNode) el.parentNode.removeChild(el);
            }
          });
        }

        /* Restore singleton "always-include" values from
           data-cd-singleton-value. Originally added because SB walked
           every [name^="properties["] input and set value="" while
           booting — that emptied our hidden inputs for
           _Creatine/_Multivitamin/_Omega-3. SB is gone so this is a
           no-op in practice, but kept as a defensive pattern. */
        form.querySelectorAll('[data-cd-singleton-value]').forEach(function(el) {
          var v = el.getAttribute('data-cd-singleton-value');
          if (v) el.value = v;
        });

        /* === V2 inline-flavor mode: 3-Boxes-of-Whey-with-3-different-flavors path ===
           When a multi-box quantity option is expanded and has N inline
           flavor dropdowns, each dropdown selection becomes a SEPARATE
           line item (qty 1) instead of N copies of one variant. Avoids
           the "selected 3 different flavors but cart has 3× chocolate"
           bug. Discounts get applied via Shopify automatic discount
           rules at checkout (set up in admin: Discounts → Automatic). */
        var mixItems = null;
        var inMixMode = false;
        /* Read cadence-selected selling_plan once so mix-mode line items
           inherit it (without this, subscription customers in mix-mode
           get charged as one-time on multi-item submissions). */
        var planInput = section.querySelector('[data-cadence-selling-plan]');
        var sellingPlanId = (planInput && planInput.value) ? parseInt(planInput.value, 10) : null;
        var v2Container = section.querySelector('[data-quantity-v2]');
        if (v2Container) {
          var expandedOpt = v2Container.querySelector('.product-box__quantity-option--v2.is-expanded');
          if (expandedOpt) {
            var v2Selects = expandedOpt.querySelectorAll('[data-qty-flavor-select]');
            if (v2Selects.length > 1) {
              var v2Items = [];
              var allFilledV2 = true;
              v2Selects.forEach(function(d) {
                var flav = d.value;
                if (!flav) { allFilledV2 = false; return; }
                /* Find a variant matching this flavor (and the current formula
                   if the product is multi-formula like Hydration). */
                var matchVariant = null;
                for (var i = 0; i < variants.length; i++) {
                  var v = variants[i];
                  var opts = [v.option1, v.option2, v.option3];
                  if (flavorOptionIndex >= 0 && opts[flavorOptionIndex] !== flav) continue;
                  if (formulaOptionIndex >= 0 && currentSelections.formula && opts[formulaOptionIndex] !== currentSelections.formula) continue;
                  matchVariant = v; break;
                }
                if (matchVariant) {
                  var v2Item = { id: matchVariant.id, quantity: 1, properties: { 'Flavor': flav } };
                  if (sellingPlanId) v2Item.selling_plan = sellingPlanId;
                  v2Items.push(v2Item);
                } else {
                  allFilledV2 = false;
                }
              });
              if (!allFilledV2 || v2Items.length === 0) {
                (window.cxToast ? window.cxToast('Please select all flavors before adding to cart.', 'error') : alert('Please select all flavors before adding to cart.'));
                return;
              }
              mixItems = v2Items;
              inMixMode = true;
            }
          }
        }

        /* === Legacy V1 mix toggle (kept for safety; superseded by V2 inline above) === */
        if (!inMixMode) {
          var mixSec = section.querySelector('[data-mix-flavor-section]');
          var mixToggle = section.querySelector('[data-flavor-toggle]');
          var inLegacyMix = mixToggle && mixToggle.getAttribute('data-active') === 'mix' && mixSec && mixSec.classList.contains('is-visible');
          if (inLegacyMix) {
            var dropdowns = mixSec.querySelectorAll('.product-box__mix-flavor-select');
            mixItems = [];
            var allFilled = true;
            dropdowns.forEach(function(d) {
              var flav = d.value;
              if (!flav) { allFilled = false; return; }
              var matchVariant = null;
              for (var i = 0; i < variants.length; i++) {
                var v = variants[i];
                var opts = [v.option1, v.option2, v.option3];
                if (flavorOptionIndex >= 0 && opts[flavorOptionIndex] !== flav) continue;
                if (formulaOptionIndex >= 0 && currentSelections.formula && opts[formulaOptionIndex] !== currentSelections.formula) continue;
                matchVariant = v; break;
              }
              if (matchVariant) {
                var mixItem = { id: matchVariant.id, quantity: 1, properties: { 'Flavor': flav } };
                if (sellingPlanId) mixItem.selling_plan = sellingPlanId;
                mixItems.push(mixItem);
              } else { allFilled = false; }
            });
            if (!allFilled || mixItems.length === 0) {
              (window.cxToast ? window.cxToast('Please select all flavors before adding to cart.', 'error') : alert('Please select all flavors before adding to cart.'));
              return;
            }
            inMixMode = true;
          }
        }

        /* === Flavor-block validation — CRITICAL for SystemX bundles ===
           The form has novalidate=novalidate on it (so the SB widget's
           injected inputs can't block submission via HTML5 :required).
           That means a customer CAN click ATC without picking any
           flavors — Hydration / Whey / Pre / BCAA selects would all
           submit value="" and the cart line stores empty properties.
           SB unbundling at order-create reads bundled_variants[].value
           and matches against properties[<name>] — an empty match fails
           entirely. That breaks fulfillment: wrong/no flavors shipped,
           customer returns, manual re-send. Cost compounds with order
           volume.

           Defense: explicitly check every [data-flavor-select] inside
           [data-flavor-block] has a non-empty value. Block submission
           and surface which group(s) are missing. Mix-mode paths (V2
           inline + legacy V1 toggle) have their own validation already
           — this only fires when we're submitting the visible flavor
           block as a single line item. */
        if (flavorBlockEl && !inMixMode) {
          /* Friendly labels for each data-flavor-group key. BCAA is an
             acronym (renders ugly as title-case "Bcaa"); pre-workout
             reads better with both words capitalized. Anything not in
             this map falls back to capitalize-first-letter. */
          var GROUP_LABELS = { 'hydration': 'Hydration', 'protein': 'Protein', 'pre-workout': 'Pre-Workout', 'bcaa': 'BCAAs' };
          var requiredSelects = flavorBlockEl.querySelectorAll('[data-flavor-select]');
          var missingGroups = [];
          var firstEmpty = null;
          var missingCount = 0;
          requiredSelects.forEach(function(sel) {
            if (!sel.value) {
              missingCount++;
              if (!firstEmpty) firstEmpty = sel;
              var groupEl = sel.closest('[data-flavor-group]');
              var groupKey = groupEl ? groupEl.getAttribute('data-flavor-group') : 'flavor';
              var label = GROUP_LABELS[groupKey] || (groupKey.charAt(0).toUpperCase() + groupKey.slice(1));
              if (missingGroups.indexOf(label) === -1) missingGroups.push(label);
            }
          });
          if (missingGroups.length > 0) {
            /* Show inline error banner above the ATC button instead of
               a browser alert. Banner element lives in the section
               markup as [data-pb-atc-error] (hidden by default).
               Auto-clears when the customer changes any flavor select
               so the banner doesn't linger after they start fixing it. */
            var errBanner = section.querySelector('[data-pb-atc-error]');
            if (errBanner) {
              errBanner.textContent = 'Please select your ' + missingGroups.join(' • ') + ' flavor' + (missingCount > 1 ? 's' : '') + ' to continue.';
              errBanner.removeAttribute('hidden');
              if (!errBanner._pbErrBound) {
                errBanner._pbErrBound = true;
                flavorBlockEl.addEventListener('change', function() {
                  errBanner.setAttribute('hidden', '');
                  errBanner.textContent = '';
                });
              }
            } else {
              /* Fallback: section is missing the banner placeholder
                 (e.g. older deploys, custom templates) — fall back to
                 the alert so the customer still sees the warning. */
              (window.cxToast ? window.cxToast('Please select all flavors before adding to cart:\n• ' + missingGroups.join('\n• '), 'error') : alert('Please select all flavors before adding to cart:\n• ' + missingGroups.join('\n• ')));
            }
            if (firstEmpty && typeof firstEmpty.focus === 'function') {
              firstEmpty.focus();
              if (typeof firstEmpty.scrollIntoView === 'function') {
                firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }
            return;
          }
        }

        var formData = new FormData(form);

        if (directToCheckout) {
          /* Add to cart then redirect straight to /checkout. This is a
             "Buy Now" button — it must NOT open the cart drawer, or the
             drawer flashes for a frame before the redirect fires.

             The 'X-Cart-Drawer-Source: cart-drawer' header makes
             cart-drawer.js's global /cart/add fetch interceptor treat
             this request as internal (isInternal() === true) and skip
             dispatching the 'cart-update' event that auto-opens the
             drawer. Scoped to the direct-to-checkout branch ONLY — the
             normal ATC path below still opens the drawer everywhere else. */
          atcButton.classList.add('loading');
          atcButton.disabled = true;
          (inMixMode
            ? fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Cart-Drawer-Source': 'cart-drawer'
                },
                body: JSON.stringify({ items: mixItems })
              })
            : fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'X-Cart-Drawer-Source': 'cart-drawer' },
                body: formData
              })
          )
            .then(function(res) { return res.json(); })
            .then(function() { window.location.href = '/checkout'; })
            .catch(function() {
              atcButton.classList.remove('loading');
              atcButton.disabled = false;
            });
        } else {
          /* Add to cart then trigger the new <cx-cart-drawer> to refresh
             and auto-open via a cart-update CustomEvent. The drawer's
             _onCartUpdate handler runs _refresh() (which updates body,
             footer, badges, and runs auto-gift logic) and then open().

             Legacy code here targeted the old <cart-drawer> element by
             name and silently no-op'd after the rebuild to <cx-cart-drawer>.
             Items WERE being added to /cart/add.js but the drawer never
             opened, making it look like ATC was broken. */
          atcButton.classList.add('loading');
          atcButton.disabled = true;

          (inMixMode
            ? fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: mixItems })
              })
            : fetch('/cart/add.js', { method: 'POST', body: formData })
          )
            .then(function(res) {
              if (!res.ok) {
                return res.json().then(function(err) {
                  throw new Error(err.description || err.message || 'Failed to add to cart');
                });
              }
              return res.json();
            })
            .then(function() {
              document.dispatchEvent(new CustomEvent('cart-update', {
                detail: { source: 'product-box-atc' }
              }));
            })
            .catch(function(err) {
              console.error('ATC error:', err);
              (window.cxToast ? window.cxToast(err.message || 'Could not add to cart', 'error') : alert(err.message || 'Could not add to cart'));
            })
            .finally(function() {
              atcButton.classList.remove('loading');
              atcButton.disabled = false;
            });
        }
      });
    }
    /* Apply per-formula discount overrides on init, then refresh prices */
    if (typeof applyFormulaDiscounts === 'function') {
      applyFormulaDiscounts();
      if (typeof updateVariant === 'function') {
        try { updateVariant(); } catch(e) {}
      }
    }

    /* ============================================================
       Sticky ATC Bar — IntersectionObserver + content sync
       Reads from the buy-box's selected card so it always matches
       what the user sees. Tier 1 (selected card) doesn't need
       flavorOptionIndex, so it works even on host products that
       don't define a Flavor option.
       ============================================================ */
    var stickyAtc = section.querySelector('[data-sticky-atc]');
    if (stickyAtc) {
      var stickyName = stickyAtc.querySelector('[data-sticky-name]');
      var stickyVariant = stickyAtc.querySelector('[data-sticky-variant]');
      var stickyImage = stickyAtc.querySelector('[data-sticky-image]');
      var stickyBtn = stickyAtc.querySelector('[data-sticky-btn]');
      var stickyText = stickyAtc.querySelector('[data-sticky-text]');
      var rawSep = stickyAtc.getAttribute('data-separator');
      var stickySeparator = rawSep ? ' ' + rawSep.replace(/^\s+|\s+$/g, '') + ' ' : ' / ';
      var stickyPlaceholder = stickyAtc.getAttribute('data-placeholder') || 'Select your flavors';

      var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
      if (inDesignMode) stickyAtc.classList.add('is-visible');

      if (window.visualViewport) {
        var vv = window.visualViewport;
        var updateStickyVpOffset = function() {
          var offset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
          stickyAtc.style.setProperty('--sticky-vp-offset', offset + 'px');
        };
        vv.addEventListener('resize', updateStickyVpOffset);
        vv.addEventListener('scroll', updateStickyVpOffset);
        updateStickyVpOffset();
      }

      var stickyOutOfView = false;
      var stickyDisplayAfterDesktop = cfg.stickyDisplayAfterDesktop;
      var stickyDisplayAfterMobile = cfg.stickyDisplayAfterMobile;
      var stickyMq = window.matchMedia('(max-width: 749px)');
      function stickyApplyVis() {
        var t = stickyMq.matches ? stickyDisplayAfterMobile : stickyDisplayAfterDesktop;
        var pastT = t === 0 || window.scrollY > t;
        if (stickyOutOfView && pastT) stickyAtc.classList.add('is-visible');
        else stickyAtc.classList.remove('is-visible');
      }

      if (!inDesignMode && atcButton && 'IntersectionObserver' in window) {
        var stickyObs = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            stickyOutOfView = !e.isIntersecting;
            stickyApplyVis();
          });
        }, { rootMargin: '0px 0px -10px 0px', threshold: 0 });
        stickyObs.observe(atcButton);
        window.addEventListener('scroll', stickyApplyVis, { passive: true });
        if (stickyMq.addEventListener) stickyMq.addEventListener('change', stickyApplyVis);
        else if (stickyMq.addListener) stickyMq.addListener(stickyApplyVis);
      }

      function getFlavorDisplay() {
        // V2 inline flavors: when a multi-box quantity option is expanded with its own
        // flavor dropdowns, prefer those (they represent the user's actual cart selections).
        var v2Container = section.querySelector('[data-quantity-v2]');
        if (v2Container) {
          var expandedOpt = v2Container.querySelector('.product-box__quantity-option--v2.is-expanded');
          if (expandedOpt) {
            var v2Selects = expandedOpt.querySelectorAll('[data-qty-flavor-select]');
            if (v2Selects.length > 0) {
              var v2Picked = [];
              v2Selects.forEach(function(s) {
                if (s.value) v2Picked.push(s.value);
              });
              return v2Picked.length ? v2Picked.join(stickySeparator) : stickyPlaceholder;
            }
            // No selects in this option (e.g. 1-box) → fall through to single-flavor below
          }
        }
        // Legacy v1 toggle path (kept for safety; v1 deleted but guarding doesn't hurt)
        var mixToggle = section.querySelector('[data-flavor-toggle]');
        var mixSec = section.querySelector('[data-mix-flavor-section]');
        var inMix = mixToggle && mixToggle.getAttribute('data-active') === 'mix' && mixSec && mixSec.classList.contains('is-visible');
        if (inMix) {
          var picked = [];
          mixSec.querySelectorAll('.product-box__mix-flavor-select').forEach(function(s) {
            if (s.value && !s.disabled) picked.push(s.value);
          });
          return picked.length ? picked.join(stickySeparator) : stickyPlaceholder;
        }
        return currentSelections.flavor || '';
      }

      function stripWidth(url) {
        if (!url) return url;
        return url.replace(/([?&])width=\d+(&|$)/, function(_, pre, post) { return post === '&' ? pre : ''; }).replace(/[?&]$/, '');
      }

      function getCardImageSrc() {
        /* Resolve which flavor's image to show, in priority order, so the sticky
           thumbnail always matches what the shopper sees:
             1. an explicit per-box pick (v2 quantity dropdowns, then legacy v1 mix)
             2. the selected flavor card (server default + click = the visual truth)
             3. JS selection state
           Reading currentSelections.flavor alone was the bug: it lags the card
           selection (cards are same-price, so nothing refreshes the banner),
           leaving the thumbnail on the first/default variant. */
        var imageFlavor = '';
        var v2c = section.querySelector('[data-quantity-v2]');
        if (v2c) {
          var v2exp = v2c.querySelector('.product-box__quantity-option--v2.is-expanded');
          if (v2exp) {
            var v2s = v2exp.querySelectorAll('[data-qty-flavor-select]');
            for (var q = 0; q < v2s.length; q++) { if (v2s[q].value) { imageFlavor = v2s[q].value; break; } }
          }
        }
        if (!imageFlavor) {
          var mixToggle = section.querySelector('[data-flavor-toggle]');
          var mixSec = section.querySelector('[data-mix-flavor-section]');
          if (mixToggle && mixToggle.getAttribute('data-active') === 'mix' && mixSec && mixSec.classList.contains('is-visible')) {
            var sels = mixSec.querySelectorAll('.product-box__mix-flavor-select');
            for (var s = 0; s < sels.length; s++) { if (sels[s].value && !sels[s].disabled) { imageFlavor = sels[s].value; break; } }
          }
        }
        if (!imageFlavor) {
          var selCard = section.querySelector('.product-box__flavor-card.is-selected');
          if (selCard) imageFlavor = selCard.getAttribute('data-flavor-value') || '';
        }
        if (!imageFlavor) imageFlavor = currentSelections.flavor || '';
        if (!imageFlavor) return null;

        /* Tier 1: the flavor card whose data-flavor-value matches the resolved
           flavor — the authoritative selection. We deliberately do NOT trust
           .is-selected here: it can desync from the active variant (e.g. after a
           quantity switch), which left the sticky thumbnail on the wrong image. */
        var card = null;
        var cards = section.querySelectorAll('.product-box__flavor-card');
        for (var ci = 0; ci < cards.length; ci++) {
          if (cards[ci].getAttribute('data-flavor-value') === imageFlavor) { card = cards[ci]; break; }
        }
        /* Fallback: an explicitly selected card, if value matching found nothing. */
        if (!card) { card = section.querySelector('.product-box__flavor-card.is-selected'); }
        if (card) {
          var cardImg = card.querySelector('.product-box__flavor-card-image img');
          if (cardImg) {
            var cardSrc = cardImg.getAttribute('src') || cardImg.getAttribute('data-src') || '';
            if (cardSrc) return stripWidth(cardSrc);
          }
        }

        /* Tier 2: carousel slide whose data-media-alt matches flavor name */
        var fl = String(imageFlavor).toLowerCase().trim();
        var slides = section.querySelectorAll('[data-carousel] .product-box__image-slide');
        for (var si = 0; si < slides.length; si++) {
          if (slides[si].getAttribute('data-media-alt') === fl) {
            var slideImg = slides[si].querySelector('img');
            if (slideImg) {
              var slideSrc = slideImg.getAttribute('src') || slideImg.getAttribute('data-src') || '';
              if (slideSrc) return stripWidth(slideSrc);
            }
          }
        }

        /* Tier 3: variant.featured_image via findBaseVariant (flavor+formula match) */
        if (typeof findBaseVariant === 'function') {
          var v = findBaseVariant();
          if (v && v.featured_image) {
            var img = v.featured_image;
            return (typeof img === 'object' && img.src) ? img.src : String(img);
          }
        }

        /* Tier 4: whatever's currently in the carousel's first slide */
        var fs = section.querySelector('[data-carousel] .product-box__image-slide img');
        if (fs) {
          var fsSrc = fs.getAttribute('src') || fs.getAttribute('data-src') || '';
          if (fsSrc) return stripWidth(fsSrc);
        }
        return null;
      }

      function getActiveFormulaName() {
        /* Read .is-active first — switchProduct toggles that correctly. */
        var active = section.querySelector('.product-box__formula-group.is-active .product-box__formula-group-title');
        if (active && active.textContent.trim()) return active.textContent.trim();
        if (currentSelections.formula) {
          var groups = section.querySelectorAll('.product-box__formula-group');
          for (var i = 0; i < groups.length; i++) {
            if (groups[i].getAttribute('data-formula-group') === currentSelections.formula) {
              var t = groups[i].querySelector('.product-box__formula-group-title');
              if (t && t.textContent.trim()) return t.textContent.trim();
            }
          }
        }
        var main = section.querySelector('.product-box__title');
        return main && main.textContent.trim() ? main.textContent.trim() : '';
      }

      function updateStickyBanner() {
        if (stickyName) {
          var nm = getActiveFormulaName();
          if (nm && stickyName.textContent !== nm) stickyName.textContent = nm;
        }
        if (stickyVariant) {
          var fl = getFlavorDisplay();
          stickyVariant.textContent = fl || stickyPlaceholder;
        }
        if (stickyImage) {
          var src = getCardImageSrc();
          if (src) {
            var sep = src.indexOf('?') === -1 ? '?' : '&';
            var full = src + sep + 'width=200';
            if (stickyImage.getAttribute('src') !== full) stickyImage.setAttribute('src', full);
          }
        }
        if (stickyText && atcText) stickyText.textContent = atcText.textContent;
        if (stickyBtn && atcButton) stickyBtn.disabled = atcButton.disabled;
      }

      /* Sticky button delegates to the in-flow ATC */
      if (stickyBtn && atcButton) {
        stickyBtn.addEventListener('click', function(e) {
          e.preventDefault();
          atcButton.click();
        });
      }

      /* Mirror price/availability via MutationObserver on atcText */
      if (atcText && 'MutationObserver' in window) {
        new MutationObserver(updateStickyBanner).observe(atcText, { childList: true, characterData: true, subtree: true });
      }
      section.querySelectorAll('.product-box__mix-flavor-select').forEach(function(s) {
        s.addEventListener('change', updateStickyBanner);
      });
      // V2 inline flavor selects — pipe their changes into the sticky banner
      section.querySelectorAll('[data-qty-flavor-select]').forEach(function(s) {
        s.addEventListener('change', updateStickyBanner);
      });
      // Flavor cards are same-price, so the atcText observer never fires on a
      // flavor change — refresh the sticky banner explicitly (small delay so the
      // card click handler updates currentSelections + images first).
      section.querySelectorAll('.product-box__flavor-card').forEach(function(c) {
        c.addEventListener('click', function() { setTimeout(updateStickyBanner, 60); });
      });
      var sbToggle = section.querySelector('[data-flavor-toggle]');
      if (sbToggle) sbToggle.addEventListener('click', function() { setTimeout(updateStickyBanner, 50); });
      if (typeof qtyOptions !== 'undefined') {
        qtyOptions.forEach(function(o) { o.addEventListener('click', function() { setTimeout(updateStickyBanner, 50); }); });
      }
      updateStickyBanner();
    }
  })();

  }

  function initAll() {
    var configs = window.__pbConfigs || {};
    Object.keys(configs).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

/* -----------------------------------------------------------------------------
   Quantity Block v2 (inline-flavor) initialization
   ----------------------------------------------------------------------------- */
(function() {
  function initV2(root) {
    var containers = (root || document).querySelectorAll('[data-quantity-v2]');
    if (!containers.length) return;

    containers.forEach(function(container) {
      var options = container.querySelectorAll('.product-box__quantity-option--v2');
      if (!options.length) return;

      // Locate the parent product-box section so we can read formula groups
      var section = container.closest('[id^="shopify-section-"]') || document;

      // Parse flavor → colour map from data attribute (set by Liquid from flavor_colors JSON setting)
      var flavorColors = {};
      try {
        var raw = container.getAttribute('data-flavor-colors');
        if (raw) flavorColors = JSON.parse(raw);
      } catch (e) {
        // Silent — bad JSON falls back to empty map
      }

      // Read available flavors for a given formula by walking that group's flavor-card buttons.
      // Falls back to the union of all formula groups' flavors if formulaValue isn't found.
      function getFlavorsForFormula(formulaValue) {
        var group = formulaValue && section.querySelector(
          '.product-box__formula-group[data-formula-group="' + formulaValue + '"]'
        );
        var cards = group
          ? group.querySelectorAll('.product-box__flavor-card[data-flavor-value]')
          : section.querySelectorAll('.product-box__flavor-card[data-flavor-value]');
        var flavors = [];
        cards.forEach(function(card) {
          var f = card.getAttribute('data-flavor-value');
          if (f && flavors.indexOf(f) === -1) flavors.push(f);
        });
        return flavors;
      }

      // Read placeholder prefix from the container's data attribute (set by Liquid from flavor_dropdown_placeholder_text).
      // Trim trailing whitespace so concatenation always has exactly one space before the number.
      var flavorPlaceholderPrefix = (container.getAttribute('data-flavor-placeholder') || 'Select Flavor').replace(/\s+$/, '');

      // Rebuild every v2 dropdown's <option> list to match `flavors`.
      // Preserves the user's current selection if still valid; otherwise resets to placeholder.
      function rebuildSelects(flavors) {
        container.querySelectorAll('[data-qty-flavor-select]').forEach(function(sel) {
          var idx = sel.getAttribute('data-qty-flavor-index') || '1';
          var prevValue = sel.value;
          // Wipe existing options
          while (sel.firstChild) sel.removeChild(sel.firstChild);
          // Placeholder
          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.disabled = true;
          placeholder.selected = true;
          placeholder.textContent = flavorPlaceholderPrefix + ' ' + idx;
          sel.appendChild(placeholder);
          // Real options
          flavors.forEach(function(f) {
            var opt = document.createElement('option');
            opt.value = f;
            opt.textContent = f;
            sel.appendChild(opt);
          });
          // Restore previous value if still valid
          if (prevValue && flavors.indexOf(prevValue) !== -1) {
            sel.value = prevValue;
          }
          // Fire change so the colour dot repaints
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // Initial sync: pick currently-active formula group's flavors
      function syncToActiveFormula() {
        var activeGroup = section.querySelector('.product-box__formula-group.is-active');
        var formulaValue = activeGroup && activeGroup.getAttribute('data-formula-group');
        rebuildSelects(getFlavorsForFormula(formulaValue));
      }
      syncToActiveFormula();

      // Pre-fill the flavor dropdowns with the flavor the shopper is viewing (the
      // selected flavor card), so a multi-box default never leaves ATC blocked on
      // empty required selects. A dropdown the shopper changed by hand is left alone.
      function prefillFlavors() {
        var card = section.querySelector('.product-box__flavor-card.is-selected[data-flavor-value]');
        var flavor = card && card.getAttribute('data-flavor-value');
        if (!flavor) return;
        container.querySelectorAll('[data-qty-flavor-select]').forEach(function(sel) {
          if (sel.getAttribute('data-user-set') === 'true' && sel.value) return;
          var hasOption = false;
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === flavor) { hasOption = true; break; }
          }
          if (!hasOption || sel.value === flavor) return;
          sel.value = flavor;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      container.querySelectorAll('[data-qty-flavor-select]').forEach(function(sel) {
        sel.addEventListener('change', function(e) {
          if (e.isTrusted) sel.setAttribute('data-user-set', 'true');
        });
      });
      prefillFlavors();

      // Listen for flavor-card clicks anywhere in the section. When the formula changes,
      // rebuild the dropdowns to match the new formula's flavor list.
      section.querySelectorAll('.product-box__flavor-card[data-formula-value]').forEach(function(card) {
        card.addEventListener('click', function() {
          var formulaValue = card.getAttribute('data-formula-value');
          // Defer to next tick so any sibling .is-active toggling happens first
          setTimeout(function() {
            rebuildSelects(getFlavorsForFormula(formulaValue));
            prefillFlavors();
          }, 0);
        });
      });
      section.querySelectorAll('.product-box__flavor-card:not([data-formula-value])').forEach(function(card) {
        card.addEventListener('click', function() { setTimeout(prefillFlavors, 0); });
      });

      // Sync required attr: only the currently expanded option's selects are required
      function syncRequired() {
        options.forEach(function(opt) {
          var expanded = opt.classList.contains('is-expanded');
          opt.querySelectorAll('[data-qty-flavor-select]').forEach(function(sel) {
            if (expanded) sel.setAttribute('required', 'required');
            else sel.removeAttribute('required');
          });
        });
      }
      syncRequired();

      // Click on an option: idempotent — always re-sync state on every click.
      // (Previous early-return on already-selected was unreliable when the user
      //  clicked while a transition was mid-flight, leaving siblings stuck expanded.)
      options.forEach(function(opt) {
        opt.addEventListener('click', function(e) {
          // Don't trigger if the click is on a select / dot wrap (those are interactive)
          if (e.target.closest('[data-qty-flavor-select]') ||
              e.target.closest('.product-box__qty-flavor-wrap')) return;

          options.forEach(function(o) {
            if (o === opt) {
              o.classList.add('is-selected');
              o.classList.add('is-expanded');
              // Swap role for nested-interactive WCAG compliance.
              o.setAttribute('role', 'group');
              o.setAttribute('aria-label', 'Selected quantity option');
              o.removeAttribute('tabindex');
              o.setAttribute('aria-checked', 'true');
            } else {
              o.classList.remove('is-selected');
              o.classList.remove('is-expanded');
              o.setAttribute('role', 'radio');
              o.removeAttribute('aria-label');
              o.setAttribute('tabindex', '0');
              o.setAttribute('aria-checked', 'false');
            }
          });
          syncRequired();
        });

        // Sync select state → wrap[data-has-value] for the dot styling.
        // Dot colour comes from flavorColors[selectedValue], else falls back to --pb-color-primary.
        opt.querySelectorAll('[data-qty-flavor-select]').forEach(function(sel) {
          var wrap = sel.closest('.product-box__qty-flavor-wrap');
          var dot = wrap && wrap.querySelector('[data-qty-flavor-dot]');
          function paintDot() {
            var val = sel.value || '';
            var has = val.length > 0;
            if (wrap) wrap.setAttribute('data-has-value', has ? 'true' : 'false');
            if (dot) {
              if (has) {
                var color = flavorColors[val] || 'var(--pb-color-primary, #A6A6A6)';
                dot.style.backgroundColor = color;
              } else {
                dot.style.backgroundColor = 'transparent';
              }
            }
          }
          sel.addEventListener('change', paintDot);
          paintDot();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initV2(); });
  } else {
    initV2();
  }
  // Re-init on Shopify section reload (theme editor)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) { initV2(e.target); });
  }
})();

/* -----------------------------------------------------------------------------
   Cadence Block — one-time vs subscription picker
   Wires [data-cadence-option] clicks to:
     - is-selected class toggle (visual)
     - hidden name="selling_plan" input update (cart payload)
     - ATC button label price + suffix sync (visible label)
   Reads price from [data-cadence-price-cents] (Liquid cents int) and
   suffix from [data-cadence-suffix] (e.g. "/mo"). Idempotent per block.
   ----------------------------------------------------------------------------- */
(function() {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function applyCadence(block, opt) {
    if (!opt) return;
    var options = block.querySelectorAll('[data-cadence-option]');
    for (var i = 0; i < options.length; i++) options[i].classList.remove('is-selected');
    opt.classList.add('is-selected');

    var planInput = block.querySelector('[data-cadence-selling-plan]');
    if (planInput) planInput.value = opt.getAttribute('data-cadence-plan') || '';

    var section = block.closest('[data-section-id]');
    if (!section) return;
    var sid = section.getAttribute('data-section-id');
    var cfg = (window.__pbConfigs && window.__pbConfigs[sid]) || {};
    var ctaLabel = cfg.ctaLabel || 'ADD TO CART';

    var priceAttr = opt.getAttribute('data-cadence-price-cents');
    var priceCents = priceAttr ? parseInt(priceAttr, 10) : NaN;
    if (isNaN(priceCents)) return;

    var suffix = opt.getAttribute('data-cadence-suffix') || '';
    var texts = section.querySelectorAll('[data-atc-text]');
    for (var j = 0; j < texts.length; j++) {
      var btn = texts[j].closest('[data-atc-button]');
      if (btn && btn.disabled) continue; /* leave SOLD OUT alone */
      texts[j].textContent = ctaLabel + '  -  ' + formatMoney(priceCents) + suffix;
    }
  }

  function initBlock(block) {
    if (block.__cadenceBound) return;
    block.__cadenceBound = true;

    /* Initial sync — match ATC label to server-rendered is-selected option
       so a sub_default page doesn't briefly show one-time price on the button. */
    var initial = block.querySelector('[data-cadence-option].is-selected');
    if (initial) applyCadence(block, initial);

    block.addEventListener('click', function(e) {
      var opt = e.target.closest('[data-cadence-option]');
      if (opt && block.contains(opt)) applyCadence(block, opt);
    });
  }

  function initAll(root) {
    var blocks = (root || document).querySelectorAll('[data-cadence-block]');
    for (var i = 0; i < blocks.length; i++) initBlock(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) { initAll(e.target); });
  }
})();
